export default __webpack_public_path__ + "static/media/group05.b5f1db47.svg";